const KiB = 1024;
const MiB = KiB ** 2;
const GiB = KiB ** 3;
const TiB = KiB ** 4;
const PiB = KiB ** 5;

function count(dividend: number, divisor: number, unit: string) {
  return `${(dividend / divisor).toFixed(2).replace(".00", "")} ${unit}`;
}

export function format(value: number) {
  if (typeof value !== "number") {
    value = Number(value);
  }
  if (value < KiB) {
    return count(value, 1, "Byte");
  }
  if (value < MiB) {
    return count(value, KiB, "KiB");
  }
  if (value < GiB) {
    return count(value, MiB, "MiB");
  }
  if (value < TiB) {
    return count(value, GiB, "GiB");
  }
  if (value < PiB) {
    return count(value, TiB, "TiB");
  }
  return count(value, PiB, "PiB");
}
